<script>
export default {
    render() {
        return this.$scopedSlots.default({
            entitlements: this.entitlements,
            unlimited: this.unlimited,
            maxdevices: this.maxdevices
        })
    },
    data: () => ({
        entitlements: [],
        maxdevices: 0,
        unlimited: false
    }),
    // mounted not called because of the render
    created: function() {
        this.$portalapi.get('/myaccount/currententitlements').then((response) => {
            this.entitlements = response.data
            this.$log.onDebug("Entitlements:" + JSON.stringify(this.entitlements))
            this.unlimited = this.entitlements.find(product => product.devices === null)
            if ( ! this.unlimited) 
                this.maxdevices = this.entitlements.reduce((acc, val) => {
                    const devices = typeof val.product.devices === 'number' ? val.product.devices : 0;
                    return acc + devices;
                }, 0);
            this.$log.onDebug("maxdevices=" + this.maxdevices)
        })
        .catch((error) => {
            this.$log.onError('error fetching entitlements')
        })
    }
}
</script>

